<script>
  import { _ } from 'svelte-i18n'
  import { router } from 'tinro'
  import {
    currentPage,
    userDetails,
    avatarImageSrc,
    searchTerm,
    leftMenuToggled,
  } from './DataStore'

  import { logout } from '../utils/ApiUtils.svelte'
  import SendFeedbackModal from '../pages/SendFeedback/SendFeedbackModal.svelte'
  import GettingStartedModal from '../pages/GettingStarted/GettingStartedModal.svelte'

  function clickChangePage(e) {
    console.log('clickChangePage', e)
    currentPage.update((x) => e)
    try {
      switch (e) {
        case 'profile':
          mixpanel.track('Teacher Account Settings Button Clicked', {
            'Button Location': 'Top Menu',
          })
          break
        default:
          break
      }
    } catch (error) {
      console.log('error mixpanel')
    }
    router.goto('/' + e)
  }

  function logoutAction() {
    console.log('logoutAction')
    mixpanel.track('Teacher Logout Button Clicked', {
      'Button Location': 'Top Menu',
    })
    logout()
  }

  function search() {
    console.log('searchTerm', $searchTerm)
    mixpanel.track('Teacher Search Button Clicked', {
      'Button Location': 'Top Menu',
      'Search Term': $searchTerm,
    })
    if ($searchTerm) {
      currentPage.update((x) => 'search')
      router.goto('/search')
    }
  }

  function sidebarToggle() {
    $leftMenuToggled = !$leftMenuToggled
  }
</script>

<SendFeedbackModal />
<GettingStartedModal />

<nav class="sb-topnav navbar navbar-expand navbar-light sticky-top s-navbar">
  <!-- Navbar Brand -->
  <a href="/">
    <div class="ps-3 header-logo" />
  </a>

  <!-- Sidebar Toggle -->
  <button
    class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 s-sidebartoggle"
    id="sidebarToggle"
    on:click={sidebarToggle}
    href="#!"><i class="fas fa-bars" /></button
  >

  <!-- Navbar Search -->
  <form
    class="d-none d-md-inline-block form-inline ms-auto me-0 me-3 my-2 my-md0"
    on:submit={search}
  >
    <div class="input-group">
      <label>
        <input
          class="form-control s-form-control s-search-bar"
          type="text"
          placeholder={$_('SEARCH_FOR')}
          bind:value={$searchTerm}
        />
      </label>
    </div>
  </form>

  <!-- Navbar-->
  <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
    <!-- Create / Add -->
    <!-- <div class="d-none d-md-inline-block me-3">
      <button class="btn btn-primary s-button-primary">
        {$_('CREATE_ADD')}
        <i
          class="fa-thin fa-plus"
          style="font-size: 1.7em; margin-left: 1rem;"
        />
      </button>
    </div> -->

    <!-- Avatar, Name and Dropdown -->
    <li class="nav-item dropdown no-arrow">
      <div
        class="nav-link"
        style="color: white"
        data-toggle="topNavbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <div class="d-none d-sm-inline-block me-3">
          <img
            alt="avatar"
            class="border rounded-circle img-profile"
            src={$avatarImageSrc}
          />
        </div>
        <span style="margin-right: 1rem">{$userDetails?.firstName}</span>
        <i class="fa-solid fa-chevron-down" style="color: #FFCC07" />
      </div>

      <ul
        class="dropdown-menu dropdown-menu-end py-0"
        style="width: 213px;"
        aria-labelledby="topNavbarDropdown"
      >
        <!-- #TODO Account upgrade / num recordings -->
        <!-- <li>
          <div class="s-dropdown-plan-info">
            <div class="s-dropdown-plan-info-plan-name">Free Plan</div>
            <div
              class="s-dropdown-plan-info-upgrade-link"
              on:click={() => alert('Upgrade')}
            >
              Upgrade
            </div>
            <div class="s-dropdown-plan-info-data-chart">Chart Goes Here</div>
            <div class="s-dropdown-plan-info-data-text">
              600 / 1000 Submitted Recordings
            </div>
          </div>
        </li> -->

        <!-- #TODO manage account page -->
        <!-- <li>
          <span
            class="dropdown-item s-dropdown-item"
            on:click={() => clickChangePage('manageaccount')}
            >{$_('MANAGE_ACCOUNT')}</span
          >
        </li> -->
        <li>
          <hr class="dropdown-divider s-dropdown-divider" />
        </li>
        <li>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span
            class="dropdown-item s-dropdown-item"
            on:click={() => clickChangePage('profile')}>{$_('PROFILE')}</span
          >
        </li>
        <li>
          <hr class="dropdown-divider s-dropdown-divider" />
        </li>
        <li>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span
            class="dropdown-item s-dropdown-item"
            href="#"
            on:click={logoutAction}>{$_('LOGOUT')}</span
          >
        </li>
      </ul>
    </li>
  </ul>
</nav>

<style>
  li {
    cursor: pointer;
  }

  .s-navbar {
    background-color: #00a094 !important;
    height: 12vh;
  }

  .header-logo {
    height: 25px;
    width: 101.47px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='207' height='51' fill='none' viewBox='0 0 207 51'%3E%3Cpath fill='%23fff' d='M57.022 4.136a7.528 7.528 0 0 0-1.44-2.131 7.423 7.423 0 0 0-2.187-1.5A6.519 6.519 0 0 0 50.9 0H19.6a6.235 6.235 0 0 0-2.558.503 7.914 7.914 0 0 0-2.125 1.5 8.47 8.47 0 0 0-1.436 2.132 6.601 6.601 0 0 0-.502 2.503v20.149a6.13 6.13 0 0 0 .502 2.573 6.95 6.95 0 0 0 1.436 2.065l.061.062a5.7 5.7 0 0 0 2.064 1.44c.81.338 1.68.509 2.558.503h20.99l8.06 6.765c.113.089 1.103.87 2 .686.301-.035.578-.187.77-.423a.89.89 0 0 0 .145-.344 6.368 6.368 0 0 0 0-1.881l-.686-4.822a6.555 6.555 0 0 0 2.497-.504 8.609 8.609 0 0 0 2.186-1.44 8.862 8.862 0 0 0 1.44-2.192 6.692 6.692 0 0 0 .498-2.507V6.639a6.684 6.684 0 0 0-.479-2.503Z'/%3E%3Cpath fill='%23FFCC07' d='M27.8 29.093a7.59 7.59 0 0 1-5.504-2.423 7.79 7.79 0 0 1-2.087-5.862 1.098 1.098 0 0 1 1.168-1.016 1.091 1.091 0 0 1 .96.747c.045.137.063.281.053.425a5.595 5.595 0 0 0 1.506 4.2 5.278 5.278 0 0 0 3.933 1.738 5.268 5.268 0 0 0 3.917-1.77 5.512 5.512 0 0 0 1.469-4.168 1.099 1.099 0 0 1 1.013-1.172 1.092 1.092 0 0 1 1.169 1.016 7.828 7.828 0 0 1-2.05 5.81 7.612 7.612 0 0 1-5.486 2.47l-.06.005Z'/%3E%3Cpath fill='%23FFCC07' d='M44.138 10.878a6.817 6.817 0 0 0-.624-1.158 6.583 6.583 0 0 0-1.154-1.373 6.326 6.326 0 0 0-1.783-1.101 6.586 6.586 0 0 0-2.562-.499H6.695a6.541 6.541 0 0 0-2.5.499 7.577 7.577 0 0 0-2.187 1.5 7.528 7.528 0 0 0-1.436 2.132 6.595 6.595 0 0 0-.502 2.507L0 36.875c.01.856.18 1.704.502 2.498a6.953 6.953 0 0 0 3.622 3.631c.794.329 1.643.5 2.501.504h.624L5.935 48.33a5.547 5.547 0 0 0-.093.503 3.079 3.079 0 0 0-.029.767c.015.403.183.785.47 1.068.17.147.375.248.596.291.938.226 1.876-.564 1.998-.686l8.047-6.756h20.988a6.61 6.61 0 0 0 2.562-.503 6.84 6.84 0 0 0 3.56-3.571 6.658 6.658 0 0 0 .503-2.569l.07-23.489a6.602 6.602 0 0 0-.469-2.507Zm-1.506 25.996a4.494 4.494 0 0 1-.375 1.816 4.847 4.847 0 0 1-1 1.506c-.429.46-.966.804-1.562 1.002a3.998 3.998 0 0 1-1.75.376H16.21l-8.314 7 1.938-7.014H6.649a4.012 4.012 0 0 1-1.75-.376 4.18 4.18 0 0 1-1.563-1.002 3.975 3.975 0 0 1-1-1.506 4.493 4.493 0 0 1-.375-1.816l.07-23.489a4.493 4.493 0 0 1 .376-1.816 4.845 4.845 0 0 1 1-1.505 5.107 5.107 0 0 1 1.562-1.002 4.012 4.012 0 0 1 1.75-.377h31.296a3.984 3.984 0 0 1 1.75.377 4.47 4.47 0 0 1 1.558 1.016c.424.434.763.945 1 1.505.25.573.377 1.191.375 1.816l-.066 23.49Z'/%3E%3Cpath fill='%23fff' d='M128.529 8.652c-3.026 0-5.447 1.115-7.216 3.293-.69-2.48-3.946-3.335-6.869-3.293h-.338l-1.061 4.704h.854c.601 0 1.352-.023 1.769.386.298.36.443.823.404 1.29l.042 19.47h5.274V21.2c0-4.964 2.111-8.045 5.518-8.045 2.782 0 4.194 1.929 4.194 5.73v15.652h5.274V18.343c0-7.146-4.054-9.691-7.845-9.691Zm-26.904-.018c-6.714 0-10.721 4.869-10.721 13.026 0 8.374 4.077 12.985 11.477 12.985 3.256 0 6.423-.89 7.751-1.727l.23-.15-.657-4.47c-1.159.819-4.359 2.22-6.996 2.174-1.037-.052-2.548-.099-3.927-1.148-1.38-1.05-2.276-2.936-2.567-5.58h14.865l.047-.371c.121-1.12.184-2.246.187-3.373 0-9.889-6.071-11.366-9.689-11.366ZM96.22 19.826c.234-3.326 1.407-7.057 5.382-7.057 3.753 0 4.565 3.199 4.565 5.88v1.19l-9.947-.013Zm104.759-11.31-5.56 20.036-6.325-20.036h-5.63l8.943 27.384a1.657 1.657 0 0 1 0 1.332c-.127.254-.54.828-3.857 1.11-1.027.09-1.877.113-2.473.113.354 1.518.704 3.037 1.051 4.558a19.13 19.13 0 0 0 3.027-.14c.958-.09 1.902-.29 2.815-.594 3.115-1.063 4.439-3.293 5.41-6.501l8.136-27.286-5.537.024Zm-20.007 21.123a1.744 1.744 0 0 1-.389-1.27v-12.02c0-4.865-3.35-7.655-9.197-7.655-2.411 0-5.944.47-8.614 1.75l-.272.132.549 4.742.553-.31c1.408-.795 4.552-2.145 7.296-2.145 3.036 0 4.453 1.246 4.453 3.923v2.122l-3.045.047c-7.399.099-10.848 2.653-10.848 8.044 0 4.822 2.984 7.706 7.976 7.706 3.693 0 5.579-1.505 6.476-2.653 1.027 2.328 4.265 2.658 5.991 2.658h.643l1.009-4.705h-.845c-.586.01-1.328.033-1.736-.366Zm-5.672-6.803v2.823c0 4.798-5.016 4.85-5.227 4.85-1.535 0-3.186-1.181-3.186-3.764 0-2.695 1.698-3.82 5.869-3.876l2.544-.033Zm-94.742-3.942c-3.242-1.082-4.392-1.797-4.392-3.655 0-.63 0-2.437 3.43-2.555a5.748 5.748 0 0 1 2.576.348c.676.33.755 1.064.704 2.037l-.028.847 4.715-.88v-.334c.066-1.307.024-2.676-.699-3.791l-.136-.193c-.802-1.153-2.055-1.487-3.05-1.77a12.347 12.347 0 0 0-2.627-.394s-.615-.038-1.178-.038c-5.748 0-9.046 2.592-9.046 7.118 0 5.645 5.227 7.057 8.352 7.884 1.989.523 4.025 1.374 4.025 3.694 0 1.97-1.572 3.053-4.054 3.024-1.609 0-3.336-.343-4.035-.94-.699-.598-.774-.941-.661-2.254l.042-.522-4.74.621-.037.334c-.248 2.3-.084 4.648 3.552 6.116a22.56 22.56 0 0 0 6.18.964c5.959 0 9.243-2.686 9.243-7.56.019-4.987-3.223-6.44-8.136-8.1Zm69.799 0c-3.238-1.082-4.388-1.797-4.388-3.655 0-.63 0-2.437 3.43-2.555a5.757 5.757 0 0 1 2.576.348c.676.33.756 1.064.704 2.037l-.028.847 4.692-.88v-.334c.066-1.307 0-2.676-.704-3.791l-.136-.193c-.798-1.153-2.05-1.487-3.045-1.77a12.326 12.326 0 0 0-2.628-.394s-.614-.038-1.177-.038c-5.753 0-9.051 2.592-9.051 7.118 0 5.645 5.231 7.057 8.356 7.884 1.99.523 4.021 1.374 4.021 3.694 0 1.97-1.567 3.053-4.049 3.024-1.609 0-3.336-.343-4.035-.94-.699-.598-.774-.941-.666-2.254l.047-.522-4.721.621-.032.334c-.249 2.3-.085 4.648 3.551 6.116a22.6 22.6 0 0 0 6.166.936c5.963 0 9.243-2.686 9.243-7.56.01-4.959-3.209-6.412-8.126-8.073Z'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: cover;
    margin-left: 6vw;
  }

  .img-profile {
    width: 40px;
    background: #f8f9fa;
  }

  label {
    position: relative;
  }

  label:before {
    content: '';
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0px;
    width: 19px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='19' fill='none' viewBox='0 0 19 19'%3E%3Cpath fill='%23323232' fill-rule='evenodd' d='M8.867 2.252a6.84 6.84 0 1 0 0 13.68 6.84 6.84 0 0 0 0-13.68ZM.189 9.092a8.677 8.677 0 1 1 17.355 0 8.677 8.677 0 0 1-17.355 0Z' clip-rule='evenodd'/%3E%3Cpath fill='%23323232' fill-rule='evenodd' d='M14.788 15.012c.358-.358 0-1.224 1.67.372l1.634 1.633a.919.919 0 1 1-1.3 1.3l-1.633-1.634c-1.596-1.67-.73-1.312-.371-1.67Z' clip-rule='evenodd'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
  }

  .s-search-bar {
    padding: 10px 35px;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    border-radius: 14px;

    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1em;
    display: flex;
    align-items: center;
  }

  .s-sidebartoggle {
    padding-top: 10px;
  }

  .s-form-control {
    margin: 0px;
    width: 200px;
  }

  /* .s-dropdown-plan-info {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 0.6875em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.5);

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      'plan-name upgrade-link'
      'data-chart data-chart'
      'data-text data-text';

    padding: 1vh 4vw;
  }

  .s-dropdown-plan-info-plan-name {
    grid-area: plan-name;
  }

  .s-dropdown-plan-info-upgrade-link {
    grid-area: upgrade-link;
    margin-left: auto;
    margin-right: 0;
    text-decoration-line: underline;

    color: #00a094;
    cursor: pointer;
  }

  .s-dropdown-plan-info-data-chart {
    grid-area: data-chart;
  }

  .s-dropdown-plan-info-data-text {
    grid-area: data-text;
  }  */

  .s-dropdown-item {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1em;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #00a094;
  }

  .s-dropdown-item:active {
    background-color: #e9ecef;
  }

  .s-dropdown-divider {
    border-color: rgba(188, 188, 188, 0.25);
    background-color: rgba(188, 188, 188, 0.25);
    margin: 0px;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    /* .s-dropdown-plan-info {
      padding: 1vh 2vw;
    } */
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .header-logo {
      height: 40.8px;
      width: 165.6px;
      margin-left: 2vw;
    }
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .header-logo {
      height: 51px;
      width: 207px;
    }

    .s-sidebartoggle {
      display: none;
    }

    .s-form-control {
      margin: 0px;
      width: 300px;
    }

    /* .s-dropdown-plan-info {
      padding: 1vh 1vw;
    } */
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  }
</style>
